var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container_avatar"},[_c('img',{staticStyle:{"borderRadius":"50% width: 100%","height":"100%"},attrs:{"src":_vm.avatarUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }